<!-- Contenedor principal -->
<div class="container-fluid py-3">
    <div class="row g-3 justify-content-center">
      <div class="col-12 col-sm-6 col-md-4" *ngFor="let clientCard of getClientCardsByStatus('doing')">
        <div class="card mobile-card" >
          <div class="card-header d-flex justify-content-between align-items-center">
            <span class="location text-muted">{{clientCard.destination}}</span>
            <div class="profile-picture">
              <img [src]="clientCard.imageUrl" alt="Profile">
            </div>
          </div>
          <div class="card-body">
            <h5 class="card-title">{{clientCard.name}} {{clientCard.lastname}}</h5>
            <p class="card-text text-muted">Llegada: 12/02/2024</p>
            <mat-icon (click)="openClientChat(clientCard)">chat</mat-icon>
          </div>
          <div class="card-footer d-flex justify-content-around">
            <i class="bi bi-chat text-primary fs-4"></i>
            <i class="bi bi-person text-primary fs-4"></i>
          </div>
        </div>
      </div>

    </div>
  </div>

  <!-- Barra de navegación inferior -->
  <nav class="navbar fixed-bottom navbar-light bg-light shadow-lg">
    <div class="container-fluid d-flex justify-content-around">
      <a href="#" class="text-muted text-decoration-none">
        <i class="bi bi-compass fs-4"></i>
        <p class="small m-0">Discover</p>
      </a>
      <a href="#" class="text-muted text-decoration-none">
        <i class="bi bi-grid fs-4"></i>
        <p class="small m-0">Apps</p>
      </a>
      <a href="#" class="text-muted text-decoration-none">
        <i class="bi bi-person-circle fs-4"></i>
        <p class="small m-0">Profile</p>
      </a>
    </div>
  </nav>
